// !DEPRICATED feb-05-2026
// Icons
// import ManOutlined from '@ant-design/icons/ManOutlined'
// import WomanOutlined from '@ant-design/icons/WomanOutlined'
import { FemaleIcon, MaleIcon } from '@lua-frontend/numu-ui'
import { FC } from 'react'
import { Avatar } from '../../atoms/avatar'
import { UserProfileType } from './user-profile.types'



export const UserProfile: FC<UserProfileType> = ({
  imgUrl,
  gender,
  age,
  city,
  label,
  icons,
  fullname,
  socialMediaUrl,
}) => {
  return (
    <div className="flex h-8 w-[230px]">
      <Avatar height={32} width={32} src={imgUrl} />
      <div className="ml-[5px] flex h-9 w-full flex-col items-start justify-start">
        <div className="flex w-[90%] items-center">
          <span className="non-italic mr-1 max-w-[116px] overflow-hidden text-ellipsis whitespace-nowrap font-montserrat text-base font-semibold text-dark-gray lg:text-sm">
            {socialMediaUrl && socialMediaUrl !== '' ? (
              <a
                href={socialMediaUrl}
                target="_blank"
                rel="noreferrer"
                className="text-dark-gray no-underline"
              >
                {label}
              </a>
            ) : (
              label
            )}
          </span>

          <div className="flex w-1/4 justify-start">{icons}</div>
        </div>
        <div className="flex h-full w-[130px] items-center justify-start ">
          {age && (
            <span className="mr-1 font-montserrat font-light text-xs text-grey-50">
              {age}
            </span>
          )}
          {gender?.toLowerCase() === 'male' ? (
               <div className="mr-1 text-xs text-grey-50" >
                 <MaleIcon/>
                 </div>
            ) : null
          }

          {
            gender?.toLowerCase() === 'female' ? 
            <div className="mr-1 text-xs text-grey-50" >
            <FemaleIcon/>
            </div>: null
          }        
          
            
          {city && (
            <span className="mr-1 w-[70px] overflow-hidden text-ellipsis whitespace-nowrap font-montserrat  text-xs text-grey-50">
              {city ? city : ''}
            </span>
          )}
          {fullname && (
            <span className="mr-1 w-[70px] overflow-hidden text-ellipsis whitespace-nowrap font-montserrat text-sm text-grey-50 lg:text-xs">
              {fullname ? fullname : ''}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}